import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName } from '../utils';

/** 増減簿価設定 */
enum IncDecBookValSetting {
  beginTerm = '1',
  beginTermEndFirstHalf = '2',
  endQuarter = '3',
  endPreviousMonth = '4',
  endMonth = '5',
}

const nameConfig = {
  beginTerm: new Map([
    [Locale.ja, '期首'],
    [Locale.en, 'Begin Term'],
  ]),

  beginTermEndFirstHalf: new Map([
    [Locale.ja, '期首上期末'],
    [Locale.en, 'Begin Term End First Half'],
  ]),

  endQuarter: new Map([
    [Locale.ja, '四半期末'],
    [Locale.en, 'End Quarter'],
  ]),

  endPreviousMonth: new Map([
    [Locale.ja, '前月末'],
    [Locale.en, 'End Previous Month'],
  ]),

  endMonth: new Map([
    [Locale.ja, '当月末'],
    [Locale.en, 'End Month'],
  ]),
};

const toDisplay = enumToName(IncDecBookValSetting, nameConfig);
const toDisplayWithPrefix = enumToName(IncDecBookValSetting, nameConfig, { prefix: true });

export const incDecBookValSetting = {
  enum: IncDecBookValSetting,
  nameConfig,
  toDisplay,
  toDisplayWithPrefix,
};
export type { IncDecBookValSetting };
